import { format2 } from 'utils/number';
import { formatCurrency } from 'pages/afe-catalog/structuring/cost-utils';

// Shared cell formatters for the map-query expand tables. Em dash is the
// canonical empty-cell placeholder across every typed expand.
export const DASH = '—';

// Reuse the shared currency formatter so negatives render -$1,234.56 (not
// $-1,234.56), cents are preserved, and nullish shows an em-dash — one source
// of truth with the AFE cost columns.
export const money = formatCurrency;

export const num = (n: number | null | undefined): string => {
  if (n === null || n === undefined) return DASH;
  return format2(n);
};
